export type PriorityScale = 1 | 2 | 3 | 4 | 5;

export const PRIORITY_SCALES: PriorityScale[] = [1, 2, 3, 4, 5];

export function weightToPriorityScale(weight: number): PriorityScale {
  return Math.min(5, Math.max(1, Math.round(weight * 4) + 1)) as PriorityScale;
}

export function priorityScaleToWeight(scale: PriorityScale | number): number {
  return (Number(scale) - 1) / 4;
}

export const PRIORITY_WEIGHT_VALUES: Record<PriorityScale, string> = {
  1: '0',
  2: '0.25',
  3: '0.5',
  4: '0.75',
  5: '1',
};
